import { alpha, ThemeOptions } from "@mui/material"

const muiPopover: ThemeOptions["components"] = {
  MuiPopover: {
    styleOverrides: {
      paper: ({ theme }) => ({
        boxShadow: `0px 4px 20px ${alpha(theme.palette.mockup.primary60, 0.1)}`,
        borderRadius: "8px",
        border: `1px solid ${theme.palette.mockup.neutral40}`,
      }),
    },
  },
}

export default muiPopover
